export function webSitesList(state) {
  return state.webSitesList;
}
export function webSelectedSites(state) {
  return state.webSelectedSites;
}